import { useIntl } from '@/intl'
import { RevWrapper } from '@/scopes/products/pages/components/Legacy/UserReviews/Teaser/RevWrapper'
import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks'
import { horizontalGap, tk, Typography, verticalGap } from '@sunwebgroup/ui-components'
import { useState } from 'react'
import { styled, useTheme } from 'styled-components'
import { MostBookedByLabel } from '../Overview/MostBookedByLabel'
import { Extended } from '../Result/Extended'
import { ActionButtons } from './ActionButtons'
import { LegalDisclamer } from './LegalDisclamer'
import { NoReviewsMessage } from './NoReviewsMessage'
import { Rating } from './Rating'
import { Reviews } from './Reviews'

const RatingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${tk('spacing_lg')};
  flex-wrap: wrap;
  ${verticalGap('spacing_md')}

  @media ${tk('mq_tablet')} {
    flex-direction: row;
    ${horizontalGap('spacing_sm')}
    align-items: center;

    & > * {
      margin-bottom: unset;
    }
  }
`

export function Teaser() {
  const [showExtendedModal, setShowExtendedModal] = useState(false)
  const [showLegalDisclamerModal, setShowLegalDisclamerModal] = useState(false)
  const { reviewsAmount, isFetched } = useUserReviewsInitialData()
  const theme = useTheme()

  const spacingLg = String(tk('spacing_lg')({ theme }))

  const intl = useIntl()

  const openExtendedModal = () => {
    setShowExtendedModal(true)
  }
  const closeExtendedModal = () => {
    setShowExtendedModal(false)
  }

  const openLegalDisclamerModal = () => {
    setShowLegalDisclamerModal(true)
  }
  const closeLegalDisclamerModal = () => {
    setShowLegalDisclamerModal(false)
  }

  if (isFetched && !reviewsAmount) {
    return (
      <div>
        <div style={{ marginBottom: spacingLg }}>
          <Typography $variant="heading-md">{intl.formatMessage({ id: 'reviews_teaser_title' })}</Typography>
        </div>
        <NoReviewsMessage />
      </div>
    )
  }

  return (
    <>
      <div style={{ marginBottom: spacingLg }}>
        <Typography $variant="heading-md">{intl.formatMessage({ id: 'reviews_teaser_title' })}</Typography>
      </div>
      <RatingWrapper>
        <Rating onClick={openExtendedModal} />
        <MostBookedByLabel />
      </RatingWrapper>
      <RevWrapper>
        <Reviews />
      </RevWrapper>
      <ActionButtons openExtendedModal={openExtendedModal} openLegalDisclamerModal={openLegalDisclamerModal} />
      <Extended closeModal={closeExtendedModal} showModal={showExtendedModal} />
      <LegalDisclamer closeModal={closeLegalDisclamerModal} showModal={showLegalDisclamerModal} />
    </>
  )
}
